<template>
  <EditableList
    ref="list"
    :list="list"
    :pending="pending"
    :form-add-title="$t('shop.settings.addType')"
    :form-edit-title="$t('shop.settings.editType')"
    @submit="$refs.form.submit()"
    @remove="$refs.form.remove()"
  >
    <template #listElement="{ row }">
      <div
        class="d-flex align-items-center"
        style="overflow: hidden"
      >
        <span class="text-truncate">
          {{ row.name }}
        </span>
      </div>
      <span>
        <i
          v-if="row.isDefault"
          v-tippy
          :content="$t('general.default')"
          class="fas fa-star text-secondary"
        />
      </span>
    </template>

    <template #form="{edited}">
      <ProductSetTypeForm
        ref="form"
        :pending.sync="pending"
        :type="getType(edited)"
        @close="$refs.list.close()"
        @updated="$emit('updated', $event)"
      />
    </template>
  </EditableList>
</template>

<script>
import { mapGetters } from 'vuex';
import EditableList from '@/components/settings/EditableList';
import colors from '@/utils/colors';
import ProductSetTypeForm from './ProductSetTypeForm';

export default {
  props: {
    list: Array,
  },
  data: () => ({
    removePending: null,
    pending: false,
    selected: null,
    add: false,
    pendingRestore: false,
  }),
  components: {
    EditableList,
    ProductSetTypeForm,
  },
  computed: {
    ...mapGetters(['payee']),
  },
  methods: {
    colors,
    getType(id) {
      return this.list.find((x) => x.id === id);
    },
  },
};
</script>
<style lang="scss" scoped>

  .group-border {
    padding: 1rem;
  }

  .color-box {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  .text-strikethrough {
    text-decoration: line-through;
  }

  .client-property {
    padding: 0.3rem 0.6rem;
    border-radius: 10px;
    border: 2px solid #eee;
    margin-top: 6px;
    font-size: 1rem;
    line-height: 1.2;
    cursor: pointer;
    transition: border-color 300ms, margin-right 300ms;

    &:hover {
      border-color: #999;
    }
    &.selected {
      margin-right: -20px;
      background-color: rgba($blue, 0.1);
      border-color: $darkblue;
    }
  }

  .add-client-property {
    border: 2px solid $blue;
    background-color: $blue;
    color: white;

    &:hover {
      border-color: $darkblue;
    }

    &.selected {
      margin-right: -20px;
      background-color: $darkblue;
      border-color: $darkblue;
    }
  }

  .client-details-enter-active,
  .client-details-leave-active {
    transition: opacity 200ms, transform 200ms;
  }

  .client-details-enter, .client-details-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }
</style>
